export default {
  user: null,
  groups: {
    list: {},
    user: []
  }
}
